import React from 'react';
import classNames from 'classnames';
import { ReactComponent as Home } from 'Icons/home.svg';
import { ReactComponent as Order } from 'Icons/order.svg';
import { isDesmetSupplier } from 'Utils/index';


const sidePanel = [
    {label: 'Overview', icon: <Home />, id: 1},
    {label: 'My Orders', icon: <Order />, id: 2},
    {label: 'Transportation Requests', icon: <Order />, id: 3}
]

const SidePanel = (props) => {
    const isSupplier = isDesmetSupplier();
    return (
        <div className={'sidePanel'}>
            {(sidePanel || []).map(el => {
                if(!isSupplier && el.id == 3) {
                    return false;
                }
                if(isSupplier && el.id == 1) {
                    return false;
                }
                return (<div key={el.id}
                    className={classNames("sideList curP", {
                        'active': props.selectedTab == el.id
                    })} onClick={() => props.onClickTab(el)}>
                    <div className="sideLabel">
                        {el.icon} 
                        <div>{el.label}</div>
                    </div>
                </div>)
            })}
        </div>
    )
}

export default SidePanel
